import axios from '../axios';

export const show = (lang) => {
  return axios.get(`/for-designers-section?lang=${lang}`);
};

export const submit = (payload) => {
  return axios.post('/for-designers-section', payload);
};
